import { FC } from 'react';
import {
  OrganisationOptionProps,
  OrganisationToggleProps,
} from './organisationToggle.type';
import Tooltip from '../tooltip/tooltip';
import { OrganisationToggleEnum } from '../../pages/userManagement/userManagement.type';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'organisation-toggle';

const OrganisationToggle: FC<OrganisationToggleProps> = (props) => {
  const prefix: string = idPrefix;
  const buttonSize: string = props.buttonSize || 'h-10 w-14';
  const iconSize: string = props.iconSize || 'w-[18px] h-[18px]';
  const getKey: (opt: OrganisationOptionProps) => OrganisationToggleEnum =
    props.getKey || ((opt: OrganisationOptionProps) => opt.value);

  return (
    <div
      className="flex items-center gap-2 mr-3"
      {...getIdAttributes(prefix, 'container')}
    >
      <div
        className="flex bg-INPUT_THEME_COLOR rounded-full p-1 gap-2"
        {...getIdAttributes(prefix, 'toggle-group')}
      >
        {props.options.map((opt) => {
          const key: OrganisationToggleEnum = getKey(opt);
          const isSelected: boolean = props.selected === key;

          return (
            <Tooltip key={key} tooltipContent={String(opt.label)}>
              <button
                onClick={() => props.onSelect(key)}
                className={`flex items-center justify-center rounded-full ${buttonSize} ${
                  isSelected ? 'bg-black text-white' : 'text-black'
                }`}
                {...getIdAttributes(prefix, `option-${key}`)}
              >
                <img
                  src={isSelected ? opt.activeIcon : opt.inActiveIcon}
                  alt={'icon'}
                  className={iconSize}
                  {...getIdAttributes(prefix, `option-${key}`)}
                />
              </button>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default OrganisationToggle;
